import React from 'react';

class TextInputMaterial extends React.Component {
    render() {
        return (
            <div style={{...this.props.style}}>
                {this.props.title ? 
                <div style={{marginBottom:5}}>
                    <span style={{fontSize:14, color:"#ccc",}}>{this.props.title}</span>
                </div> : null} 
                {this.props.multiline ?
                    <textarea type={this.props.type || "text"} className="text-input-material" style={{...this.props.styleInput}} 
                        placeholder={this.props.placeholder || undefined} maxLength={this.props.maxLength || undefined} 
                        rows={this.props.rows || 2} onBlur={this.props.onBlur}
                        defaultValue={this.props.value || ""} onChange={this.props.onChange}>
                    </textarea> 
                    :   
                    <input type={this.props.type || "text"} className="text-input-material" style={{...this.props.styleInput}}
                        placeholder={this.props.placeholder || undefined} maxLength={this.props.maxLength || undefined} onKeyDown={this.props.onKeyDown}
                        defaultValue={this.props.value || ""} onChange={this.props.onChange}>
                    </input>
                }
            </div>
        );
    }
}

export default TextInputMaterial